export default "__VITE_ASSET__ae43f2f6__"